import SettingsInstallationPanelMixinPanel from '../components_mixins/SettingsInstallationPanelMixinPanel';

export const SettingsInstallationPanelMixin = {
    data() {
        return {
            showSettingsInstallationPanel: false,
            settingsInstallation: null,
        };
    },
    provide() {
        return { parentSettingsInstallationPanelMixin: this };
    },
    components: { SettingsInstallationPanelMixinPanel },
    methods: {
        openSettingsInstallationPanel(installation) {
            this.settingsInstallation = installation;
            this.showSettingsInstallationPanel = true;
        },
    },
};
